import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AuthService } from '@libs/core/auth-pt';
import { PlatformDetectionService } from '@libs/util/shared';

export const initApp = (authService: AuthService, platformDetectionService: PlatformDetectionService) => async () => {
  if (platformDetectionService.isAndroid()) {
    // Hide the native splashscreen on Android
    await SplashScreen.hide();
  }

  /**
   * Show the splashscreen. It's not the native splashscreen, but a simple
   * native page with the same image shown in the native splashscreen.
   */
  await SplashScreen.show({
    autoHide: false,
    fadeInDuration: 0,
  });

  /**
   * Check if the user is logged in.
   *
   * If yes, go to the main page.
   * If no, go to the login page.
   *
   * A user is considered to be logged in when there's a valid access token in the storage.
   * If the access token is invalid, try to obtain a new one using a refresh token.
   * If obtaining a new access token using the refresh token fails, consider the user as logged out.
   */
  await authService.autoLogin();
};
